// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3rkwB","inner":"Footer_inner__UQg9S","nextIcon":"Footer_nextIcon__3M53h","innerLeft":"Footer_innerLeft__36U4E"};